import { Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

const HomePage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero Section */}
      <section className="relative min-h-screen flex items-center overflow-hidden">
        {/* Background Image with Overlay */}
        <div className="absolute inset-0">
          <img
            src="https://public.readdy.ai/ai/img_res/4c3025a8ea73ca5de0daef3aff74d288.jpg"
            alt="Grande Imprimerie Background"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
        </div>

        {/* Content */}
        <div className="relative z-10 max-w-7xl mx-auto px-6 py-32 w-full">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            {/* Left Content */}
            <div>
              <h1 className="text-white text-6xl lg:text-7xl font-black leading-tight mb-6">
                IMPRESSION PREMIUM<br />
                <span className="text-[#E63946]">POUR VOTRE</span><br />
                RÉUSSITE PROFESSIONNELLE
              </h1>

              <p className="text-gray-200 text-xl lg:text-2xl font-light mb-8 flex items-center flex-wrap gap-3">
                Qualité exceptionnelle
                <span className="w-2 h-2 bg-[#E63946] rounded-full"></span>
                Livraison rapide
                <span className="w-2 h-2 bg-[#E63946] rounded-full"></span>
                Accompagnement expert
              </p>

              <div className="flex flex-wrap gap-5 mb-12">
                <Link
                  to="/commande-devis"
                  className="bg-[#E63946] text-white px-10 py-4 rounded-full font-bold text-base shadow-2xl hover:bg-[#d32f3c] transition-all duration-300 hover:scale-105 flex items-center gap-2 whitespace-nowrap cursor-pointer"
                >
                  Demander un Devis
                  <i className="ri-arrow-right-line"></i>
                </Link>
                <Link
                  to="/contact"
                  className="border-2 border-white text-white px-10 py-4 rounded-full font-bold text-base hover:bg-white hover:text-black transition-all duration-300 whitespace-nowrap cursor-pointer"
                >
                  Commander maintenant
                </Link>
              </div>

              {/* Stats */}
              <div className="flex flex-wrap gap-8">
                <div className="text-center">
                  <p className="text-[#E63946] text-5xl font-bold mb-2">500+</p>
                  <p className="text-gray-300 text-sm">Clients Satisfaits</p>
                </div>
                <div className="w-px bg-gray-600"></div>
                <div className="text-center">
                  <p className="text-[#E63946] text-5xl font-bold mb-2">10+</p>
                  <p className="text-gray-300 text-sm">Ans d'Expertise</p>
                </div>
                <div className="w-px bg-gray-600"></div>
                <div className="text-center">
                  <p className="text-[#E63946] text-5xl font-bold mb-2">24h</p>
                  <p className="text-gray-300 text-sm">Livraison Express</p>
                </div>
              </div>
            </div>

            {/* Right Content - Floating Card */}
            <div className="hidden lg:block">
              <div
                className="bg-white rounded-[32px] overflow-hidden shadow-2xl transform -rotate-3 hover:rotate-0 transition-transform duration-500"
                style={{ boxShadow: '0 20px 60px rgba(0, 0, 0, 0.5)' }}
              >
                <div className="relative">
                  {/* Badge */}
                  <div className="absolute top-6 left-6 bg-white/90 backdrop-blur-sm px-6 py-3 rounded-full shadow-lg flex items-center gap-2 z-10">
                    <i className="ri-star-fill text-yellow-500"></i>
                    <span className="text-gray-800 font-semibold text-sm">Qualité Certifiée</span>
                  </div>

                  {/* Image */}
                  <img
                    src="https://readdy.ai/api/search-image?query=Collection%20of%20premium%20printed%20materials%20business%20cards%20brochures%20banners%20flyers%20displayed%20elegantly%20on%20white%20surface%20professional%20photography%20clean%20minimalist%20background%20high%20quality%20commercial%20printing%20samples&width=600&height=700&seq=hero-card-001&orientation=portrait"
                    alt="Impression Premium"
                    className="w-full h-[500px] object-cover object-top"
                  />

                  {/* Overlay Info */}
                  <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/90 to-transparent p-8">
                    <h3 className="text-white text-2xl font-bold mb-2">
                      Impression Tous Supports
                    </h3>
                    <p className="text-gray-200 text-base">
                      Design • Branding • Marketing
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="bg-[#F8F9FA] py-24">
        <div className="max-w-7xl mx-auto px-6">
          {/* Section Header */}
          <div className="mb-16">
            <p className="text-gray-500 text-sm tracking-widest uppercase mb-4">NOS SERVICES</p>
            <h2 className="text-5xl font-bold text-black mb-4" style={{ fontFamily: 'Georgia, serif' }}>
              Solutions Complètes
            </h2>
            <p className="text-gray-600 text-lg">
              Pour tous vos besoins d'impression et de visibilité
            </p>
          </div>

          {/* Services Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10">
            {/* Service 1 - Impression Premium */}
            <div className="bg-black rounded-3xl p-8 hover:scale-105 transition-transform duration-300">
              <div className="w-14 h-14 bg-[#2D3142] rounded-full flex items-center justify-center mb-6">
                <i className="ri-printer-line text-white text-2xl"></i>
              </div>
              <h3 className="text-white text-3xl font-bold mb-6">
                Impression Tous Supports
              </h3>
              <ul className="space-y-3 mb-6">
                <li className="flex items-start gap-3">
                  <span className="w-2 h-2 bg-[#E63946] rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-white text-base">Dépliants et Brochures</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="w-2 h-2 bg-[#E63946] rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-white text-base">Bâches et Banderoles</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="w-2 h-2 bg-[#E63946] rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-white text-base">Cartes de visite</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="w-2 h-2 bg-[#E63946] rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-white text-base">Autocollants personnalisés</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="w-2 h-2 bg-[#E63946] rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-white text-base">Impression textile</span>
                </li>
              </ul>
              <p className="text-gray-400 text-sm">Qualité professionnelle garantie</p>
            </div>

            {/* Service 2 - Design & Branding */}
            <div className="relative rounded-3xl overflow-hidden hover:scale-105 transition-transform duration-300 min-h-[400px]">
              <img
                src="https://readdy.ai/api/search-image?query=Creative%20graphic%20design%20workspace%20with%20logo%20designs%20brand%20identity%20materials%20color%20palettes%20typography%20samples%20professional%20creative%20studio%20minimalist%20background%20design%20tools%20artistic%20photography&width=500&height=600&seq=service-design-001&orientation=portrait"
                alt="Design & Branding"
                className="absolute inset-0 w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/70"></div>
              
              <div className="relative z-10 p-8 h-full flex flex-col justify-between">
                <div className="bg-black/60 backdrop-blur-sm px-5 py-2 rounded-full inline-flex items-center gap-2 self-start">
                  <i className="ri-palette-line text-white text-lg"></i>
                  <span className="text-white text-sm font-semibold">Design Créatif</span>
                </div>

                <div>
                  <h3 className="text-white text-4xl font-bold mb-3">
                    Branding Complet
                  </h3>
                  <p className="text-white text-base">
                    Logo, charte graphique, identité visuelle
                  </p>
                </div>
              </div>
            </div>

            {/* Service 3 - Marketing Digital */}
            <div className="bg-white border border-gray-200 rounded-3xl p-8 hover:scale-105 transition-transform duration-300">
              <div className="relative">
                <span className="absolute -top-4 -right-4 bg-[#E63946] text-white text-xs font-bold px-3 py-1 rounded-full">
                  Nouveau
                </span>
              </div>
              <h3 className="text-black text-4xl font-bold mb-6" style={{ fontFamily: 'Georgia, serif' }}>
                Vente en Ligne
              </h3>
              <p className="text-gray-600 text-base mb-6 leading-relaxed">
                Nous accompagnons nos clients dans leur stratégie de vente en ligne avec des solutions marketing efficaces, un design professionnel et une visibilité digitale optimale.
              </p>
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20e-commerce%20online%20shopping%20interface%20laptop%20screen%20showing%20professional%20online%20store%20website%20clean%20digital%20marketing%20business%20growth%20concept%20minimalist%20photography%20bright%20background&width=500&height=300&seq=service-ecommerce-001&orientation=landscape"
                alt="Vente en Ligne"
                className="w-full h-48 object-cover object-top rounded-2xl"
              />
            </div>
          </div>

          <div className="text-center mt-12">
            <Link
              to="/services"
              className="inline-flex items-center gap-2 text-[#E63946] font-bold text-base hover:gap-4 transition-all duration-300 cursor-pointer"
            >
              Découvrir tous nos services
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="bg-[#F5F5F5] py-24">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <span className="bg-red-100 text-[#E63946] px-6 py-2 rounded-full text-sm font-semibold inline-block mb-6">
              Témoignages Clients
            </span>
            <h2 className="text-5xl font-bold text-black">
              Ce Que Disent<br />
              Nos Clients Satisfaits
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {/* Testimonial 1 */}
            <div className="bg-white rounded-2xl p-8 shadow-sm hover:shadow-lg transition-shadow duration-300">
              <div className="flex items-center gap-4 mb-6">
                <div className="w-14 h-14 bg-gradient-to-br from-blue-400 to-blue-600 rounded-full flex items-center justify-center text-white text-xl font-bold">
                  MK
                </div>
                <div>
                  <h4 className="text-black text-lg font-bold">Marie Kalombo</h4>
                  <p className="text-gray-500 text-sm">@RestaurantLeSaveur</p>
                </div>
              </div>
              <p className="text-gray-700 text-base leading-relaxed italic">
                <i className="ri-double-quotes-l text-[#E63946] text-2xl"></i>
                Service impeccable et livraison ultra-rapide. Grande Imprimerie a transformé notre image de marque avec des menus et cartes de visite exceptionnels.
              </p>
            </div>

            {/* Testimonial 2 */}
            <div className="bg-white rounded-2xl p-8 shadow-sm hover:shadow-lg transition-shadow duration-300">
              <div className="flex items-center gap-4 mb-6">
                <div className="w-14 h-14 bg-gradient-to-br from-green-400 to-green-600 rounded-full flex items-center justify-center text-white text-xl font-bold">
                  JM
                </div>
                <div>
                  <h4 className="text-black text-lg font-bold">Jean Mukendi</h4>
                  <p className="text-gray-500 text-sm">@TechSolutionsRDC</p>
                </div>
              </div>
              <p className="text-gray-700 text-base leading-relaxed italic">
                <i className="ri-double-quotes-l text-[#E63946] text-2xl"></i>
                Qualité d'impression exceptionnelle pour nos supports marketing. Je recommande vivement Grande Imprimerie pour tous projets professionnels.
              </p>
            </div>

            {/* Testimonial 3 */}
            <div className="bg-white rounded-2xl p-8 shadow-sm hover:shadow-lg transition-shadow duration-300">
              <div className="flex items-center gap-4 mb-6">
                <div className="w-14 h-14 bg-gradient-to-br from-purple-400 to-purple-600 rounded-full flex items-center justify-center text-white text-xl font-bold">
                  GL
                </div>
                <div>
                  <h4 className="text-black text-lg font-bold">Grace Lumingu</h4>
                  <p className="text-gray-500 text-sm">@BoutiqueModa</p>
                </div>
              </div>
              <p className="text-gray-700 text-base leading-relaxed italic">
                <i className="ri-double-quotes-l text-[#E63946] text-2xl"></i>
                Accompagnement personnalisé du design à la livraison. Une équipe vraiment professionnelle qui comprend nos besoins.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Portfolio/Realisations Preview */}
      <section className="bg-white py-24">
        <div className="max-w-7xl mx-auto px-6">
          <div className="mb-16">
            <p className="text-gray-500 text-sm tracking-widest uppercase mb-4">NOTRE PORTFOLIO</p>
            <h2 className="text-6xl font-thin text-black mb-4">
              Réalisations Premium
            </h2>
            <p className="text-gray-600 text-lg">
              Découvrez nos impressions de haute qualité
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-product-shop>
            {/* Portfolio Item 1 */}
            <div className="group cursor-pointer">
              <div className="bg-[#E3F2FD] rounded-t-3xl p-8 aspect-[4/3] flex items-center justify-center overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Professional%20business%20cards%20stack%20elegant%20corporate%20identity%20design%20minimalist%20clean%20background%20premium%20quality%20print%20samples%20white%20surface%20studio%20lighting%20sharp%20focus&width=500&height=400&seq=portfolio-cards-001&orientation=squarish"
                  alt="Cartes de visite"
                  className="w-full h-full object-contain group-hover:scale-110 transition-transform duration-500"
                  style={{ filter: 'drop-shadow(0 10px 30px rgba(0,0,0,0.2))' }}
                />
              </div>
              <div className="text-center py-6">
                <h3 className="text-black text-xl font-medium mb-2">Cartes de Visite Premium</h3>
                <p className="text-gray-500 text-sm uppercase tracking-wide mb-4">Impression Papier</p>
                <button className="w-4/5 mx-auto bg-black text-white py-3 rounded-full font-bold text-sm hover:scale-105 transition-all duration-300 whitespace-nowrap cursor-pointer">
                  Demander un Devis
                </button>
                <p className="text-gray-400 text-xs mt-3">Personnalisation disponible</p>
              </div>
            </div>

            {/* Portfolio Item 2 */}
            <div className="group cursor-pointer">
              <div className="bg-[#ECEFF1] rounded-t-3xl p-8 aspect-[4/3] flex items-center justify-center overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Large%20format%20banner%20roll-up%20display%20stand%20professional%20advertising%20signage%20corporate%20branding%20clean%20neutral%20background%20commercial%20printing%20display%20studio%20photography&width=500&height=400&seq=portfolio-banner-001&orientation=squarish"
                  alt="Banderoles"
                  className="w-full h-full object-contain group-hover:scale-110 transition-transform duration-500"
                  style={{ filter: 'drop-shadow(0 10px 30px rgba(0,0,0,0.2))' }}
                />
              </div>
              <div className="text-center py-6">
                <h3 className="text-black text-xl font-medium mb-2">Bâches & Banderoles</h3>
                <p className="text-gray-500 text-sm uppercase tracking-wide mb-4">Grand Format</p>
                <button className="w-4/5 mx-auto border-2 border-black text-black py-3 rounded-full font-bold text-sm hover:bg-black hover:text-white transition-all duration-300 whitespace-nowrap cursor-pointer">
                  Demander un Devis
                </button>
                <p className="text-gray-400 text-xs mt-3">Livraison 24-48h</p>
              </div>
            </div>

            {/* Portfolio Item 3 */}
            <div className="group cursor-pointer">
              <div className="bg-[#FFF8E1] rounded-t-3xl p-8 aspect-[4/3] flex items-center justify-center overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Custom%20printed%20t-shirts%20polo%20shirts%20corporate%20apparel%20textile%20printing%20merchandise%20clean%20white%20background%20professional%20product%20photography%20studio%20lighting%20high%20quality&width=500&height=400&seq=portfolio-textile-001&orientation=squarish"
                  alt="Impression Textile"
                  className="w-full h-full object-contain group-hover:scale-110 transition-transform duration-500"
                  style={{ filter: 'drop-shadow(0 10px 30px rgba(0,0,0,0.2))' }}
                />
              </div>
              <div className="text-center py-6">
                <h3 className="text-black text-xl font-medium mb-2">Impression Textile</h3>
                <p className="text-gray-500 text-sm uppercase tracking-wide mb-4">T-shirts, Polos</p>
                <button className="w-4/5 mx-auto border-2 border-black text-black py-3 rounded-full font-bold text-sm hover:bg-black hover:text-white transition-all duration-300 whitespace-nowrap cursor-pointer">
                  Demander un Devis
                </button>
                <p className="text-gray-400 text-xs mt-3">Personnalisation disponible</p>
              </div>
            </div>
          </div>

          <div className="text-center mt-12">
            <Link
              to="/realisations"
              className="inline-flex items-center gap-2 text-[#E63946] font-bold text-base hover:gap-4 transition-all duration-300 cursor-pointer"
            >
              Voir toutes nos réalisations
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </section>

      {/* CTA Entreprises Section */}
      <section className="relative py-32 overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=Modern%20professional%20corporate%20office%20environment%20business%20team%20collaboration%20elegant%20workspace%20commercial%20printing%20services%20institutional%20clients%20minimalist%20clean%20photography&width=1920&height=800&seq=cta-entreprise-001&orientation=landscape"
            alt="Offres Entreprises"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/60 to-black/70"></div>
        </div>

        <div className="relative z-10 max-w-5xl mx-auto px-6 text-center">
          <div className="mb-12">
            <img
              src="https://readdy.ai/api/search-image?query=Professional%20corporate%20business%20meeting%20handshake%20partnership%20institutional%20clients%20elegant%20office%20setting%20commercial%20services%20high%20quality%20photography%20minimal%20background&width=1000&height=600&seq=cta-corporate-002&orientation=landscape"
              alt="Partenariat Entreprise"
              className="w-full max-w-3xl mx-auto rounded-3xl shadow-2xl"
            />
          </div>

          <h2 className="text-white text-5xl mb-6">
            <span className="font-thin">Offres </span>
            <span className="font-bold italic">Spéciales</span>
            <span className="font-thin"> pour</span>
            <br />
            <span className="font-thin">Entreprises et </span>
            <span className="font-bold italic">Institutions</span>
            <br />
            <span className="font-thin">Professionnelles</span>
          </h2>

          <a
            href="tel:0779027536"
            className="inline-flex items-center gap-3 bg-[#E63946] text-white px-12 py-5 rounded-full font-bold text-lg shadow-2xl hover:scale-105 transition-all duration-300 cursor-pointer mt-8"
            style={{ boxShadow: '0 0 40px rgba(230, 57, 70, 0.5)' }}
          >
            <i className="ri-phone-line text-2xl"></i>
            Contactez-nous : 0779027536
          </a>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default HomePage;